import { create } from 'zustand';
import { resourceApi } from '../services/api';
import type { Resource } from '../types';

interface ResourceState {
  resources: Resource[];
  loading: boolean;
  error: string | null;

  fetchResources: () => Promise<void>;
  createResource: (data: Partial<Resource>) => Promise<Resource>;
  updateResource: (id: string, data: Partial<Resource>) => Promise<Resource>;
  deleteResource: (id: string) => Promise<void>;
  getActiveResources: () => Resource[];
}

export const useResourceStore = create<ResourceState>((set, get) => ({
  resources: [],
  loading: false,
  error: null,

  fetchResources: async () => {
    set({ loading: true, error: null });
    try {
      const resources = await resourceApi.list();
      set({ resources, loading: false });
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  },

  createResource: async (data) => {
    const resource = await resourceApi.create(data);
    set((s) => ({ resources: [...s.resources, resource] }));
    return resource;
  },

  updateResource: async (id, data) => {
    const updated = await resourceApi.update(id, data);
    set((s) => ({
      resources: s.resources.map((r) => (r._id === id ? { ...r, ...updated } : r)),
    }));
    return updated;
  },

  deleteResource: async (id) => {
    await resourceApi.delete(id);
    set((s) => ({ resources: s.resources.filter((r) => r._id !== id) }));
  },

  getActiveResources: () => {
    return get().resources.filter((r) => r.active);
  },
}));
